import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'pickups' });

export const { find, create, get, patch, reducer, remove, update } = actions;

export default reducer;
